import { useEffect, useState } from "react";

const toText = (sizes) => (sizes || []).map((z) => `${z.length} | ${z.price}`).join("\n");
const parse = (text) => text.split("\n").map((line) => {
  const [l, p] = line.split("|").map((x) => (x || "").trim());
  return { length: parseFloat(l) || 0, price: (p || "").replace(/^\$/, "") };
}).filter((z) => z.length > 0);

const NumField = ({ label, value, onCommit, step, testId }) => {
  const [raw, setRaw] = useState(String(value ?? ""));
  useEffect(() => { setRaw(String(value ?? "")); }, [value]);
  return (
    <div>
      <label className="label">{label}</label>
      <input className="field" type="number" min="1" step={step} value={raw}
        onChange={(e) => { setRaw(e.target.value); const n = parseFloat(e.target.value); if (n > 0) onCommit(n); }}
        onBlur={() => setRaw(String(value ?? ""))} data-testid={testId} />
    </div>
  );
};

export const GangSettings = ({ s, set }) => {
  const [text, setText] = useState(() => toText(s.gang_sizes));
  return (
    <section className="panel p-6" data-testid="admin-gang-settings">
      <h2 className="red-title mb-4 text-xl">Gang Sheet Builder</h2>
      <div className="grid gap-4 sm:grid-cols-3">
        <NumField label="Sheet width (inches)" value={s.gang_width ?? 22} step="0.5" onCommit={(n) => set("gang_width", n)} testId="admin-gang-width" />
        <NumField label="Minimum pictures per sheet" value={s.gang_min_images ?? 6} step="1" onCommit={(n) => set("gang_min_images", Math.round(n))} testId="admin-gang-min" />
        <label className="flex items-center gap-3 self-end pb-3 text-sm"><input type="checkbox" className="h-4 w-4 accent-[#E5202A]" checked={s.gang_enabled !== false} onChange={(e) => set("gang_enabled", e.target.checked)} data-testid="admin-gang-enabled" />Show builder on site</label>
      </div>
      <label className="label mt-4">Sheet lengths & prices (one per line: length | price)</label>
      <textarea className="field min-h-[200px] font-mono-label" data-testid="admin-gang-sizes" value={text}
        onChange={(e) => { setText(e.target.value); set("gang_sizes", parse(e.target.value)); }} />
    </section>
  );
};
